import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Room from '../RoomComponent';
import MenuItem from '../MenuItemComponent';

import styles from './styles.module.css';
import translations from '../../../data';

const { general, links } = translations;

const Menu = ({ onClickParent, className, onRoomExplorerClicked }) => {
  const [menuOpened, isMenuOpened] = useState(false);
  const [disableAnimations, setDisableAnimations] = useState(true);

  return (
    <div
      className={`${className} ${styles.menu} ${
        disableAnimations ? styles.disableAnimations : ''
      }`}
    >
      {/* menu icon */}
      <div
        className={styles.menuIcon}
        onClick={() => {
          setDisableAnimations(false);

          setTimeout(() => {
            setDisableAnimations(true);
          }, 1000);

          onClickParent(menuOpened);

          isMenuOpened(!menuOpened);
        }}
      >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 62 62">
          <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
              <g>
                {/* circle */}
                <path
                  id="Layer0_39_MEMBER_0_1_STROKES"
                  data-name="Layer0 39 MEMBER 0 1 STROKES"
                  d="M61,31a28.88,28.88,0,0,1-8.78,21.2A28.88,28.88,0,0,1,31,61,28.94,28.94,0,0,1,9.78,52.22,28.88,28.88,0,0,1,1,31,28.94,28.94,0,0,1,9.78,9.78,28.94,28.94,0,0,1,31,1a28.88,28.88,0,0,1,21.2,8.78A28.94,28.94,0,0,1,61,31Z"
                  style={{
                    fill: 'none',
                    stroke: '#000',
                    strokeLinecap: 'round',
                    strokeLinejoin: 'round',
                    strokeWidth: '2px',
                  }}
                />
                {/* closed state */}
                {!menuOpened && (
                  <path
                    id="Layer0_40_1_STROKES"
                    data-name="Layer0 40 1 STROKES"
                    d="M24.06,28.41H37.94M24.06,33.59H37.94"
                    style={{
                      fill: 'none',
                      stroke: '#000',
                      strokeLinecap: 'round',
                      strokeLinejoin: 'round',
                      strokeWidth: '2px',
                    }}
                  />
                )}
                {/* open state */}
                {menuOpened && (
                  <g>
                    <line
                      x1="36.32"
                      y1="35.46"
                      x2="25.68"
                      y2="26.54"
                      style={{
                        fill: 'none',
                        stroke: '#000',
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeWidth: '2px',
                      }}
                    />
                    <line
                      x1="36.32"
                      y1="26.54"
                      x2="25.68"
                      y2="35.46"
                      style={{
                        fill: 'none',
                        stroke: '#000',
                        strokeLinecap: 'round',
                        strokeLinejoin: 'round',
                        strokeWidth: '2px',
                      }}
                    />
                  </g>
                )}
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div
        className={`
        ${menuOpened ? styles.isOpened : ''}
        ${styles.menuWrapper} ${
          disableAnimations ? styles.disableAnimations : ''
        }
      `}
      >
        {/* timeline bar */}
        <div className={styles.timelineBar} />
        {/* menu elements */}
        <ul className={styles.menuList}>
          <li onClick={onRoomExplorerClicked}>
            <Room
              title={general.roomExplorer}
              subtitle={general.tapToExplore}
            />
          </li>
          <li>
            <MenuItem
              item={{
                icon: 'small',
                url: links.termsAndConditions,
                name: general.termsAndConditions,
              }}
            />
          </li>
          <li>
            <MenuItem
              item={{
                icon: 'small',
                url: links.privacy,
                name: general.privacy,
              }}
            />
          </li>
          <li>
            <MenuItem
              item={{
                icon: 'big',
                url: links.site,
                name: general.site,
              }}
            />
          </li>
        </ul>
      </div>
    </div>
  );
};

Menu.propTypes = {
  onClickParent: PropTypes.func,
  className: PropTypes.string,
};

export default Menu;
